import {
  UsePaginationProps,
  usePagination,
} from 'react-instantsearch-hooks-web'

export function SearchPagination(props: UsePaginationProps) {
  const {
    pages,
    currentRefinement,
    nbHits,
    nbPages,
    isFirstPage,
    isLastPage,
    canRefine,
    refine,
    createURL,
  } = usePagination(props)

  const changePage = (page: number) => {
    window.scrollTo({
      top: 0,
    })
    refine(page)
  }

  return (
    <div className="flex items-center justify-end gap-3">
      {nbPages > 0 && (
        <>
          <button
            disabled={isFirstPage}
            className="font-medium  disabled:text-neutral-500"
            onClick={() => changePage(currentRefinement - 1)}
          >
            Previous Page
          </button>

          <button
            disabled={isLastPage}
            className="font-medium disabled:text-neutral-500"
            onClick={() => changePage(currentRefinement + 1)}
          >
            Next Page
          </button>

          <div>
            {currentRefinement + 1} / {nbPages}
          </div>
        </>
      )}
    </div>
  )
}
